import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 公共路由
const routes = [
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@/views/register'),
    hidden: true
  },
  {
    path: '/forgetPass',
    component: () => import('@/views/forgetPass'),
    hidden: true
  },
  /****   首页   *******/
  {
    path: '',
    component: ()=> import('@/views/sy'),
    redirect: 'sy',
    children: [
      {
        path: 'sy',
        component: () => import('@/views/sy'),
        name: 'Sy'
      }
    ]
  },
  /****   产品中心   *******/
  {
    path: '/product',
    component: () => import('@/views/product'),
    name:'Product',
  },
  {
    path: '/gyxj',
    component: () => import('@/views/product/gyxj'),
    name:'xlwjxj',
    children: [
      {
        path: 'specs/:type',
        component: () => import('@/views/product/toSpecs'),
        name: 'specs'
      },
      {
        path: 'tool/:type',
        component: () => import('@/views/product/toTool'),
        name: 'tool'
      },
      {
        path: 'parts/:type',
        component: () => import('@/views/product/toParts'),
        name: 'parts'
      },
      {
        path: 'apply/:type',
        component: () => import('@/views/product/toApply'),
        name: 'apply'
      }
    ]
  },
  {
    path: '/erkzq',
    component: () => import('@/views/product/erkzq'),
    name:'ljkzq',
    children: [
      {
        path: 'specs/:type',
        component: () => import('@/views/product/toSpecs'),
        name: 'specs'
      },
      {
        path: 'tool/:type',
        component: () => import('@/views/product/toTool'),
        name: 'tool'
      },
      {
        path: 'parts/:type',
        component: () => import('@/views/product/toParts'),
        name: 'parts'
      },
      {
        path: 'apply/:type',
        component: () => import('@/views/product/toApply'),
        name: 'apply'
      }
    ]
  },
  {
    path: '/sjkzq',
    component: () => import('@/views/product/sjkzq'),
    name:'sjkzq',
    children: [
      {
        path: 'specs/:type',
        component: () => import('@/views/product/toSpecs'),
        name: 'specs'
      },
      {
        path: 'tool/:type',
        component: () => import('@/views/product/toTool'),
        name: 'tool'
      },
      {
        path: 'parts/:type',
        component: () => import('@/views/product/toParts'),
        name: 'parts'
      },
      {
        path: 'apply/:type',
        component: () => import('@/views/product/toApply'),
        name: 'apply'
      }
    ]
  },
  {
    path: '/sdxxrj',
    component: () => import('@/views/product/sdxxrj'),
    name:'sdxxrj',
  },
  {
    path: '/bzsjrj',
    component: () => import('@/views/product/bzsjrj'),
    name:'bzsjrj',
  },
  {
    path: '/baoxiangang',
    component: () => import('@/views/product/baoxiangang'),
    name:'baoxiangang',
  },
  {
    path: '/bydchicun',
    component: () => import('@/views/product/bydchicun'),
    name:'bydchicun',
  },
  {
    path: '/fadongji',
    component: () => import('@/views/product/fadongji'),
    name:'bzsjrj',
  },
  {
    path: '/gwjcj',
    component: () => import('@/views/product/gwjcj'),
    name:'gwjcj',
  },
  {
    path: '/lungu',
    component: () => import('@/views/product/lungu'),
    name:'lungu',
  },
  {
    path: '/xiaci',
    component: () => import('@/views/product/xiaci'),
    name:'xiaci',
  },
  {
    path: '/software',
    component: () => import('@/views/product/sdxxrj/software'),
    name:'software',
  },
  {
    path: '/platform',
    component: () => import('@/views/product/sdxxrj/platform'),
    name:'platform',
  },
  {
    path: '/sjjcrj',
    component: () => import('@/views/product/sjjcrj'),
    name:'sjjcpt',
  },
  /****   视觉案例   *******/
  {
    path: '/solution',
    component: () => import('@/views/solution'),
    name:'solution',
  },
  {
    path: '/ydgjsxl',
    component: () => import('@/views/solution/ydgjsxl'),
    name:'sjcl',
  },
  {
    path: '/jcsb3D',
    component: () => import('@/views/solution/jcsb3D'),
    name:'jcsb3D',
  },
  {
    path: '/sjjc',
    component: () => import('@/views/solution/sjjc'),
    name:'sjjc',
  },
  {
    path: '/zxjc',
    component: () => import('@/views/solution/zxjc'),
    name:'sjyd',
  },
  {
    path: '/jcsb',
    component: () => import('@/views/solution/jcsb'),
    name:'jcsb',
  },
  /****   行业应用   *******/
  {
    path: '/application',
    component: () => import('@/views/application'),
    name:'application',
  },
  {
    path: '/xnyld',
    component: () => import('@/views/application/xnyld'),
    name:'xnyld',
  },
  {
    path: '/wl',
    component: () => import('@/views/application/wl'),
    name:'wl',
  },
  {
    path: '/fzy',
    component: () => import('@/views/application/fzy'),
    name:'fzy',
  },
  {
    path: '/qcyzdh',
    component: () => import('@/views/application/qcyzdh'),
    name:'qcyzdh',
  },
  /****   服务与支持 *******/
  {
    path: '/serviceSupport',
    component: () => import('@/views/serviceSupport'),
    name:'serviceSupport',
  },
  {
    path: '/guide',
    component: () => import('@/views/serviceSupport/guide'),
    name:'guide',
  },
  /****   关于我们   *******/
  // {
  //   path: '/aboutWe',
  //   component: () => import('@/views/aboutWe'),
  //   name:'aboutWe',
  // },
  {
    path: '/gsjj',
    component: () => import('@/views/aboutWe/gsjj'),
    name:'company',
  },
  {
    path: '/aboutContact',
    component: () => import('@/views/aboutWe/aboutContact'),
    name:'aboutContact',
  },
  /*** 公共产品详情页 ***/
  {
    path: '/productDetail/:type/:code',
    component: () => import('@/views/productDetail'),
    name:'productDetail',
  },
  /*** 获取报价 ***/
  {
    path: '/getPrice',
    component: () => import('@/views/getPrice'),
    name:'getPrice',
  },
  /*** 获取产品演示 ***/
  {
    path: '/getShow',
    component: () => import('@/views/getShow'),
    name:'getShow',
  },
  /***首页-联系我们****/
  {
    path: '/syContact',
    component: () => import('@/views/syContact'),
    name:'syContact',
  },

]


// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'hash', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes:routes
})
